import { render, staticRenderFns } from "./DocumentArchiveIndicator.vue?vue&type=template&id=e124a11a&scoped=true&"
import script from "./DocumentArchiveIndicator.vue?vue&type=script&lang=ts&"
export * from "./DocumentArchiveIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentArchiveIndicator.vue?vue&type=style&index=0&id=e124a11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e124a11a",
  null
  
)

export default component.exports